import React from 'react';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const userLang = navigator.language || navigator.userLanguage;

const ApproveReturnModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={userLang === 'zh-CN' ? '确认批准退货' : 'Confirm Return Approval'}>
      <div className="p-4">
        <p className="mb-4 text-gray-700">
          {userLang === 'zh-CN' 
            ? '警告：一旦批准退货，此操作不可撤销。客户将收到退货通知，且系统将为此商品创建退货流程。' 
            : 'Warning: Once you approve a return, this action cannot be undone. The customer will be notified and a return process will be created for this item.'}
        </p>
        <p className="mb-4 text-gray-700 font-semibold">
          {userLang === 'zh-CN' 
            ? '您确定要批准此退货请求吗？' 
            : 'Are you sure you want to approve this return request?'}
        </p>
        <div className="flex justify-end space-x-2 mt-6">
          <Button
            onClick={onClose}
            variant="secondary"
            disabled={isLoading}
          >
            {userLang === 'zh-CN' ? '取消' : 'Cancel'}
          </Button>
          <Button
            onClick={onConfirm}
            variant="primary"
            disabled={isLoading}
            isLoading={isLoading}
          >
            {userLang === 'zh-CN' ? '确认批准' : 'Confirm Approval'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ApproveReturnModal; 